import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import jsPDF from 'jspdf'; // Import jsPDF library
import { logoImage } from '../common';
import axios from '../Axiosinstance';
import logo from '../Batchescourserun/Juro.png';

const InvoiceStudent = ({ sessionId }) => {
  const [studentInfo, setStudentInfo] = useState(null);

  const invoiceData = {
    companyName: 'JURONG ACADEMY',
    companyAddress: '134 Jurong Gateway Road,#03-307L (Head Office),Singapore 600134',
    companyPhone: '(65) 6635 5724',
    companyEmail: 'ask@ja.edu.sg',
    companyWebsite: 'https://ja.edu.sg',
  };

  const styles = {
    container: {
      maxWidth: '800px',
      margin: 'auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
    },
    companyInfo: {
      marginBottom: '20px',
      textAlign: 'center',
    },
    logo: {
      width: '150px',
      marginBottom: '10px',
    },
    invoiceDetails: {
      marginBottom: '20px',
    },
    table: {
      marginBottom: '20px',
    },
    totalRow: {
      fontWeight: 'bold',
      backgroundColor: '#f2f2f2',
    },
    invoiceHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    invoiceLeft: {
      flex: '1',
    },
    invoiceRight: {
      flex: '1',
      textAlign: 'right',
    },
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/registrationadvances/info/${sessionId}`);
        setStudentInfo(response.data);
      } catch (error) {
        console.error('Error fetching student info:', error);
      }
    };

    fetchData();
  }, [sessionId]);

  const downloadInvoicePDF = async () => {
    if (!studentInfo) {
      return; // No data available to generate PDF
    }

    // Create a new PDF document
    const doc = new jsPDF();

    // Set initial position and font size
    let yPos = 40;
    doc.setFontSize(12);

    const imgWidth = 50;
    const imgHeight = 20;
    const centerX = (doc.internal.pageSize.width - imgWidth) / 2;

    doc.addImage(logo, 'JPEG', centerX, 10, imgWidth, imgHeight); // Position logo at the center

    // Company information
    const companyInfoX = 10;
    doc.text(`${invoiceData.companyName}`, companyInfoX, yPos);
    doc.text(`${invoiceData.companyAddress}`, companyInfoX, yPos + 10);
    doc.text(`${invoiceData.companyPhone}`, companyInfoX, yPos + 20);
    doc.text(`${invoiceData.companyEmail}`, companyInfoX, yPos + 30);
    doc.text(`${invoiceData.companyWebsite}`, companyInfoX, yPos + 40);

    yPos += 60;
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(18);
    doc.text('Invoice Details', 10, yPos);

    doc.setLineWidth(0.5);
    doc.line(10, yPos + 10, 200, yPos + 10);

    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    yPos += 20;
    doc.text(`Name: ${studentInfo.name}`, 10, yPos);
    doc.text(`Address: ${studentInfo.addressHome}`, 10, yPos + 10);
    doc.text(`Email: ${studentInfo.email}`, 10, yPos + 20);

    doc.text(`Invoice Number: INVJA${studentInfo.id}`, 100, yPos);
    doc.text(`Registration Date & Time: ${new Date(studentInfo.date).toLocaleString()}`, 100, yPos + 10);
    doc.text(`Bill Generated Date & Time: ${new Date(studentInfo.sessionIdDate).toLocaleString()}`, 100, yPos + 20);

    yPos += 40;
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(16);
    doc.text('Invoice Items', 10, yPos);

    doc.line(10, yPos + 5, 200, yPos + 5);

    yPos += 10;
    const tableData = {
      startY: yPos,
      head: [['Item', 'Description', 'Quantity', 'Unit Price', 'Total Amount']],
      body: [
        [
          'Registration fee',
          'Registration fee description',
          '1',
          studentInfo.amount.toString(),
          studentInfo.amount.toString(),
        ],
        ['Total', '', '', '', studentInfo.amount],
      ],
    };

    doc.autoTable(tableData);

    doc.save(`Invoice_${studentInfo.name}_${studentInfo.id}.pdf`);
  };

  const handleDownloadInvoice = () => {
    downloadInvoicePDF().catch(error => {
      console.error('Error generating PDF:', error);
    });
  };

  return (
    <div style={styles.container}>
      <div style={styles.companyInfo}>
        <img src={logoImage} alt="Company Logo" style={styles.logo} />
        <h2>{invoiceData.companyName}</h2>
        <p>{invoiceData.companyAddress}</p>
        <p>{invoiceData.companyPhone}</p>
        <p>{invoiceData.companyEmail}</p>
        <p>{invoiceData.companyWebsite}</p>
      </div>
      <div style={styles.invoiceDetails}>
        <h2>Invoice</h2>
        {studentInfo && (
          <div style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
            <div style={styles.invoiceHeader}>
              <div style={styles.invoiceLeft}>
                <p><strong>Name:</strong> {studentInfo.name}</p>
                <p><strong>Address:</strong> {studentInfo.addressHome}</p>
                <p><strong>Email:</strong> {studentInfo.email}</p>
              </div>
              <div style={styles.invoiceRight}>
                <p><strong>Invoice Number:</strong> INVJA{studentInfo.id}</p>
                <p><strong>Registertion Date & Time:</strong> {new Date(studentInfo.date).toLocaleString()}</p>
                <p><strong>Bill Generated Date & Time:</strong> {new Date(studentInfo.sessionIdDate).toLocaleString()}</p>
              </div>
            </div>

            <TableContainer component={Paper} style={styles.table}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell>Item Description</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Unit Price</TableCell>
                    <TableCell align="right">Total Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>1</TableCell>
                    <TableCell>Registration fee</TableCell>
                    <TableCell align="right">1</TableCell>
                    <TableCell align="right">{studentInfo.amount}</TableCell>
                    <TableCell align="right">{studentInfo.amount}</TableCell>
                  </TableRow>
                  <TableRow style={styles.totalRow}>
                    <TableCell colSpan={4}>Total</TableCell>
                    <TableCell align="right">{studentInfo.amount}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        <br />
        <button
          className='btn btn-primary'
          onClick={handleDownloadInvoice}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            fontWeight: 'bold',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'background-color 0.3s ease',
          }}
        >
          Download Invoice (PDF)
        </button>
      </div>
    </div>
  );
};

export default InvoiceStudent;
